/** @jsx jsx */
import { jsx } from '@emotion/core'
import { FunctionComponent } from 'react'

import { TRequest, TOffer, EPartOrigins, EPartConditions } from '~/types'
import { Request } from '~/components'
import { styles } from './styles'

interface OfferProps {
  request: TRequest
  offer: TOffer
}

export const Offer: FunctionComponent<OfferProps> = ({ request, offer }) => (
  <div css={styles.container}>
    <Request request={request} />

    <div css={styles.content}>
      <div css={styles.section}>{EPartOrigins[offer.Origin]}</div>
      <div css={styles.section}>{EPartConditions[offer.Condition]}</div>
      <div css={styles.section}>{offer.Shipment} days</div>
      <div css={styles.section}>${offer.Price}</div>
      <div
        css={[
          styles.section,
          offer.Status === 'accepted' ? styles.status.accepted : styles.status.pending,
        ]}
      >
        {offer.Status === 'accepted' ? 'accepted' : 'pending'}
      </div>
    </div>
  </div>
)
